<style>
</style>

<template>
  <div>
    <v-dialog style="z-index: 1000" v-model="dialog" width="80%">
      <v-card>
        <v-card-title>
          <!-- Word Cloud -->
          <v-spacer />
          <v-icon @click="dialog = false"> close </v-icon>
        </v-card-title>

        <v-card-text style="height: calc(80vh)">
          <wordcloud-chart style="width: 100%" />
        </v-card-text>
      </v-card>
    </v-dialog>
    <apexchart
      width="100%"
      height="500px"
      :options="chartOptions"
      :series="series"
      @click="clickHandler"
    ></apexchart>
  </div>
</template>
<script>
const VueApexCharts = () => import("vue-apexcharts");
const WordcloudChart = () => import("@/components/charts/orr/wordcloud.vue");

import series from "./data/series";
export default {
  props: ["AnnotatedChart"],
  components: {
    apexchart: VueApexCharts,
    WordcloudChart,
  },
  data() {
    return {
      dialog: false,
      series: [
        {
          data: series.monthDataSeries1.prices,
        },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: "line",
          id: "areachart-2",
        },
        annotations: {
          yaxis: [
            {
              y: 8200,
              borderColor: "#00E396",
              label: {
                borderColor: "#00E396",
                style: {
                  color: "#fff",
                  background: "#00E396",
                },
                text: "Support",
              },
            },
            {
              y: 8600,
              y2: 9000,
              borderColor: "#000",
              fillColor: "#FEB019",
              opacity: 0.2,
              label: {
                borderColor: "#333",
                style: {
                  fontSize: "10px",
                  color: "#333",
                  background: "#FEB019",
                },
                text: "Y-axis range",
              },
            },
          ],
          xaxis: [
            {
              x: new Date("23 Nov 2017").getTime(),
              strokeDashArray: 0,
              borderColor: "#775DD0",
              label: {
                borderColor: "#775DD0",
                style: {
                  color: "#fff",
                  background: "#775DD0",
                },
                text: "Anno Test",
              },
            },
            {
              x: new Date("26 Nov 2017").getTime(),
              x2: new Date("28 Nov 2017").getTime(),
              fillColor: "#B3F7CA",
              opacity: 0.4,
              label: {
                borderColor: "#B3F7CA",
                style: {
                  fontSize: "10px",
                  color: "#fff",
                  background: "#00E396",
                },
                offsetY: -10,
                text: "X-axis range",
              },
            },
          ],
          points: [
            {
              x: new Date("01 Dec 2017").getTime(),
              y: 8607.55,
              marker: {
                size: 8,
                fillColor: "#fff",
                strokeColor: "red",
                radius: 2,
                cssClass: "apexcharts-custom-class",
              },
              label: {
                borderColor: "#FF4560",
                offsetY: 0,
                style: {
                  color: "#fff",
                  background: "#FF4560",
                },

                text: "Point Annotation",
              },
            },
            {
              x: new Date("08 Dec 2017").getTime(),
              y: 9340.85,
              marker: {
                size: 0,
              },
              image: {
                path: "../../assets/images/ico-instagram.png",
              },
            },
          ],
        },
        dataLabels: {
          enabled: false,
        },
        stroke: {
          curve: "straight",
        },
        grid: {
          padding: {
            right: 30,
            left: 20,
          },
        },
        title: {
          text: "Line with explanations",
          align: "left",
        },
        labels: series.monthDataSeries1.dates,
        xaxis: {
          type: "datetime",
        },
      },
    };
  },
  methods: {
    openDialog() {
      this.dialog = true;
      // alert("openDialog " + this.dialog);
    },
    clickHandler(event) {
      // event, chartContext, config
      // console.log("click")

      // console.log(chartContext)
      // console.log(config)
      const that = this;

      // console.log(event);
      const timeout = setTimeout(() => {
        that.openDialog();
        clearTimeout(timeout);
      }, 100);
      
    },
  },
};
</script>
